import { css } from '@emotion/react';
import { Colors } from 'styles/variables';

export const draggableStyles = {
	itemContainer: css`
    /*width: 200px;*/
  `,
	itemStyles: css`
    background-color: ${Colors.WHITE};
    cursor: move;
    margin-bottom: 4px;
    width: 100%;
    overflow: hidden;
  `,
	itemButton: css`
    cursor: move;
    width: 100%;
    justify-content: left;
  `,
};
